module.exports = __webpack_public_path__ + "media/images/icons/outlined/twitter-76549028f91b4ca9d05a9be782b13c5d.svg";